import { parseISO, intervalToDuration, addSeconds, subDays, addDays, format, startOfDay, differenceInDays } from 'date-fns';
import { get } from 'lodash';

import { IConvertSecondsToMinutesAndSeconds } from '../interfaces/date.interface';

export function convertDateToSeconds(dateString: string): number {
    const date = parseISO(dateString);
    const milliseconds = date.getTime();
    const seconds = Math.floor(milliseconds / 1000);
    return seconds;
};

export function convertSecondsToHoursAndMinutes(seconds: number): IConvertSecondsToMinutesAndSeconds {
    const startDate = new Date(0);
    const endDate = addSeconds(startDate, seconds);
    const duration = intervalToDuration({ start: startDate, end: endDate });

    const hours = (duration.days || 0) * 24 + (duration.hours || 0);
    const minutes = duration.minutes;

    return {
        hours,
        minutes,
        string: `${hours ? hours + 'h' : ''} ${minutes ? minutes + 'min' : '-'}`,
    };
}

/*Oblicza roznice pomiedzy dwiema datami*/
export function timeDifference(start: string, end: string): string {
    const startDate = parseISO(start);
    const endDate = parseISO(end);
    const duration = intervalToDuration({ start: startDate, end: endDate });
        const parts = [];
    if (duration.years) parts.push(`${duration.years}y`);
    if (duration.months) parts.push(`${duration.months}mo`);
    if (duration.days) parts.push(`${duration.days}d`);
    if (duration.hours) parts.push(`${duration.hours}h`);
    if (duration.minutes) parts.push(`${duration.minutes}m`);
    return parts.join(' ');
}

export function findClosestDateBefore(date: Date): Date {
  return subDays(date, 1);
}

export function findClosestDateAfter(date: Date): Date {
  return addDays(date, 1);
}

export function formatDate(dateFormat: string, date: Date): string {
    return format(date, dateFormat);
}

export function formatMinutesToHours(totalMinutes: number): string {
    if (totalMinutes < 60) {
      return `${totalMinutes} min`;
    } else {
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      return minutes === 0 ? `${hours}h` : `${hours}h ${minutes}min`;
    }
};

export function sortRoutesByDate<T>(data: T[], propName: string = 'date'): T[] {
  return data.sort((a, b) => {
    const dateA = new Date(get(a, propName)).getTime();
    const dateB = new Date(get(b, propName)).getTime();
    return dateB - dateA;
  });
}

export function diffInDays(dateA: string, targetDate: string): number {
    try {
      const tgDate = parseISO(targetDate);
      const today = parseISO(dateA);

      const targetDayStart = startOfDay(tgDate);
      const todayDayStart = startOfDay(today);

      const daysLeft = differenceInDays(targetDayStart, todayDayStart);
      return daysLeft;
    }
    catch (error) {
      return null!;
    }
  }
